import { useEffect, useState } from "react";
import { http, formatErr } from "../../lib/api";
import { downloadB64 } from "../../lib/files";
import { usePolling } from "../../lib/usePolling";
import { toast } from "sonner";
import { Download } from "lucide-react";

export default function AgentProspetti() {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  const [blocked, setBlocked] = useState(false);
  const [inv, setInv] = useState({ number: "", date: new Date().toISOString().slice(0, 10), amount_net: "", vat_rate: "", ritenuta: "" });

  const load = async () => {
    try {
      const [p, m] = await Promise.all([
        http.get(`/crm/me/prospetti/${month}`),
        http.get(`/crm/me/commissions/month`, { params: { month } }),
      ]);
      setData({ ...p.data, computed: m.data }); setBlocked(false);
    } catch (e) { if (e?.response?.status === 403) { setBlocked(true); } else toast.error(formatErr(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [month]);
  usePolling(load, { interval: 10000, enabled: !blocked });

  const dlStatement = async () => {
    try { const { data } = await http.get(`/crm/me/commissions/statement/${month}/download`); downloadB64(data.data_b64, data.filename, data.content_type); }
    catch (e) { toast.error(formatErr(e)); }
  };

  const submitInvoice = async () => {
    if (!inv.number.trim()) return toast.error("Numero fattura richiesto.");
    try {
      await http.post(`/crm/me/prospetti/${month}/invoice`, {
        number: inv.number, date: inv.date,
        amount_net: inv.amount_net ? parseFloat(inv.amount_net) : null,
        vat_rate: inv.vat_rate ? parseFloat(inv.vat_rate) : null,
        ritenuta: inv.ritenuta ? parseFloat(inv.ritenuta) : null,
      });
      await load(); toast.success("Fattura registrata.");
    } catch (e) { toast.error(formatErr(e)); }
  };

  if (blocked) return <div data-testid="agent-prospetti-blocked" className="max-w-2xl mx-auto card-clean p-6 text-center"><h1 className="font-serif text-2xl mb-2">Prospetti</h1><p className="text-sm text-neutral-600">Disponibili dopo l'attivazione.</p></div>;

  const approved = data?.prospetto?.approved;
  const invoice = data?.invoice;
  const net = data?.computed?.sviluppo?.net_outstanding;

  return (
    <div data-testid="agent-prospetti-page" className="max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-2">
        <h1 className="font-serif text-3xl">Prospetti e fattura</h1>
        <div className="flex items-center gap-2">
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="agent-prospetto-month" className="px-3 py-2 rounded-md border text-sm" style={{ borderColor: "var(--border-silver)" }} />
          <button onClick={dlStatement} data-testid="agent-prospetto-download" className="px-3 py-2 rounded-md border text-sm flex items-center gap-1" style={{ borderColor: "var(--border-silver)" }}><Download className="w-4 h-4" /> Scarica prospetto</button>
        </div>
      </div>
      <div className="card-clean p-5 mb-4" data-testid="agent-prospetto-summary">
        <div className="text-sm">Mese: <strong>{month}</strong></div>
        <div className="text-sm">Netto dovuto (sviluppo): <strong>€ {net ?? "—"}</strong></div>
        <div className="text-sm mt-1">Stato approvazione: {approved ? <span className="text-green-700" data-testid="agent-prospetto-approved">Approvato (v{data.prospetto.version})</span> : <span className="text-amber-700" data-testid="agent-prospetto-pending">In attesa di approvazione</span>}</div>
      </div>
      <div className="card-clean p-5" data-testid="agent-invoice-block">
        <h2 className="text-lg font-semibold mb-3">Fattura agente</h2>
        {invoice ? (
          <div className="text-sm text-green-700" data-testid="agent-invoice-registered">Fattura registrata: n. {invoice.number} del {invoice.date}</div>
        ) : !approved ? (
          <p className="text-sm text-neutral-500">Potrai registrare la fattura dopo l'approvazione del prospetto da parte dell'amministratore.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
            <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Numero *</span><input value={inv.number} onChange={(e) => setInv({ ...inv, number: e.target.value })} data-testid="ai-number" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
            <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Data</span><input type="date" value={inv.date} onChange={(e) => setInv({ ...inv, date: e.target.value })} data-testid="ai-date" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
            <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Imponibile €</span><input type="number" step="0.01" value={inv.amount_net} onChange={(e) => setInv({ ...inv, amount_net: e.target.value })} data-testid="ai-net" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
            <label className="block"><span className="text-[10px] uppercase tracking-widest text-neutral-500 block mb-1">Ritenuta €</span><input type="number" step="0.01" value={inv.ritenuta} onChange={(e) => setInv({ ...inv, ritenuta: e.target.value })} data-testid="ai-ritenuta" className="w-full px-3 py-2 rounded-md border" style={{ borderColor: "var(--border-silver)" }} /></label>
            <div className="md:col-span-2"><button onClick={submitInvoice} data-testid="ai-submit" className="px-4 py-2 rounded-md text-white text-sm" style={{ background: "var(--brand-primary)" }}>Registra fattura</button></div>
          </div>
        )}
      </div>
    </div>
  );
}
